import React from 'react';
import { useCancelPolicyQuery } from 'src/common/hooks';
import { errorHandler } from 'src/common/utils/ErrorHandler';
import { Container, EmptyState, RegularText } from 'src/components';
import { metrics } from 'src/themes/Metrics';

const CancellationPolicyScreen = () => {
  const { isFetching, isError, error, data } = useCancelPolicyQuery();

  React.useEffect(() => {
    if (error) {
      errorHandler({ error });
    }
  }, [error]);

  if (isFetching || isError) {
    // return <ActivityIndicator />;
    return <EmptyState loading={isFetching} error={error} text="tripEmptyContent" />;
  }

  return (
    <Container padding={metrics.large}>
      <RegularText textAlign="left">{data?.cancelPolicy}</RegularText>
    </Container>
  );
};

export default CancellationPolicyScreen;
